import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';

import DialogHeader from 'components/DialogHeader/DialogHeader';
import { useTranslation } from 'react-i18next';

interface Props {
  title?: string | null;
  btnCloseText?: string;
  btnConfirmText?: string;
  isOpen: boolean;
  close?: () => void;
  confirm?: () => void;
  icons?: boolean;
  noHeader?: boolean;
  noButtons?: boolean;
  noCancelButton?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md';
  centered?: boolean;
  disableClose?: boolean;
  confirmDisabled?: boolean;
}

const ConfirmDialog: React.FC<Props> = ({
  isOpen,
  title,
  close,
  confirm,
  btnConfirmText,
  btnCloseText,
  children,
  icons,
  noHeader,
  noButtons,
  noCancelButton,
  maxWidth,
  centered,
  disableClose,
  confirmDisabled
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} maxWidth={maxWidth || 'sm'} fullWidth>
      {noHeader ? (
        <DialogHeader />
      ) : (
        <DialogHeader onClose={disableClose ? undefined : close || confirm}>
          {title !== null && (title ? t(title) : t('general_confirm_title'))}
        </DialogHeader>
      )}
      <DialogContent>
        {centered ? (
          <DialogContentText align="center">{children}</DialogContentText>
        ) : (
          <>{children || t('general_confirm_body')}</>
        )}
      </DialogContent>
      {!noButtons && (
        <DialogActions>
          {close && !noCancelButton && (
            <Button
              onClick={close}
              color="default"
              variant="contained"
              startIcon={icons ? <ArrowBackIos /> : undefined}
            >
              {t(btnCloseText || 'general_back')}
            </Button>
          )}
          {confirm && (
            <Button
              onClick={confirm}
              color="primary"
              variant="contained"
              endIcon={icons ? <ArrowForwardIos /> : undefined}
              disabled={confirmDisabled}
            >
              {t(btnConfirmText || 'general_ok')}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ConfirmDialog;
